<template>
	<Auth title="Recover Password">
		<template #heading>
			<h1 class="fw-bold mb-2">Recover Password</h1>
			<p class="fw-medium text-muted">Input your email and we will send you a password reset link.</p>
		</template>
		<Alert ref="alert" class="alert-danger">
			{{ message }}
		</Alert>
		<Form ref="form" @submit="onSubmit" class="mt-md-5 mt-0">
			<div class="mb-2">
				<label for="email" class="text-dark text-sm fw-semibold mb-1">Recovery Email address</label>
				<InputField id="email" v-model="email" name="email" rules="required|email" label="Email" type="email" placeholder="Email" />
			</div>
			<div class="d-flex flex-column justify-content-between align-items-center mb-4">
				<div class="w-100">
					<Button id="action" type="submit" :label="labels" :loading="loading" :done="done" :disabled="checkInput" class="btn bg-secondary text-light py-3 w-100" />
				</div>
				<div class="w-100 text-start my-2 d-flex ">
					<i class="fa fa-arrow-left me-2"></i>
					<Link :href="route('login')" class="text-dark fs-sm fw-medium d-inline d-lg-inline-block mb-1">Go Back</Link>
				</div>
			</div>
		</Form>
	</Auth>
</template>

<script lang="ts">
import { error } from '@/ts/app'
import Alert from '@/vue/components/Alert.vue'
import Button from '@/vue/components/Button.vue'
import Form from '@/vue/components/Form.vue'
import InputField from '@/vue/components/InputField.vue'
import Link from '@/vue/components/Link.vue'
import Auth from '@/vue/templates/Auth.vue'
import { ButtonLabel } from '@/vue/utils/Button'
import { AxiosError } from 'axios'
import { Component, Ref, Vue, Watch, toNative } from 'vue-facing-decorator'

@Component({
	components: {
		Auth,
		Alert,
		InputField,
		Form,
		Button,
		Link,
	},
})
class RecoverPassword extends Vue {
	message = ''

	email = ''

	loading = false
	done = false

	@Ref('form')
	readonly form!: InstanceType<typeof Form>

	@Ref('alert')
	readonly alert!: InstanceType<typeof Alert>

	@Watch('message')
	onMessageChanged(value: string) {
		const alert: HTMLDivElement = this.alert.$el
		if (value.length > 0) {
			alert.classList.add('show')
		} else {
			alert.classList.remove('show')
		}
	}

	get labels(): ButtonLabel {
		return {
			normal: 'Recover',
			loading: 'Recovering..... Password',
			done: 'Recovered Password',
		} as ButtonLabel
	}
	get checkInput(): boolean {
		return this.email.trim() === '' ? true :false
	}
	async onSubmit(payload) {
		this.loading = true
		this.message = ''
		this.$http
			.post(this.route('auth.ajax.password.recover'), payload)
			.then(() => {
				this.done = true
				this.$sweet.fire({
					title: 'Success!',
					text: 'Password reset link has been sent to your email.',
					icon: 'success',
					confirmButtonText: 'OK',
				})
			})
			.catch((e: AxiosError) => error(e, this))
			.finally(() => (this.loading = false))
	}
}

export default toNative(RecoverPassword)
</script>
